import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { successToast } from "../../Utils/utils";


export function submitRegistrationForm(firstName, lastName, email, password, activationCode, newsletter, btn){

    const url = '/registrieren'

    const success = function (data){
        window.location = data.redirect_url
    }

    const data = {
              'firstName': firstName,
              'lastName': lastName,
              'email': email,
              'password': password,
              'activationCode': activationCode,
              'newsletter': newsletter,
          }

    return ajaxRequest(url, success, data, btn)

}